import Navbar from "../../../components/Navbar";
import LeaderBoardTable from "../../../components/Student/LeaderBoardTable";

export default function LeaderBoard() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <LeaderBoardTable />
        </div>
      </section>
    </>
  );
}
